import type { GoodsData } from '@banhala/ui-kit';
import { AblyGoodsCardActionType } from '../../../../api/types';
import {
  convertRenderDataToGoodsData,
  type RenderableGoodsItem,
} from '../../../../utils/convertRenderDataToGoodsData';
import type { MarketBrandingAdsGoodsEntity } from './types';
import { isNotNil } from '../../../../utils';

export type MarketBrandingAdsGoodsData = GoodsData &
  MarketBrandingAdsGoodsEntity;

// 서버 goods_list → GoodsCard용 GoodsData 변환
export const getMarketBrandingAdsGoodsData = (
  goodsList: MarketBrandingAdsGoodsEntity[] | undefined,
): MarketBrandingAdsGoodsData[] => {
  if (!goodsList) return [];

  return goodsList
    .slice(0, 3)
    .map((goods): MarketBrandingAdsGoodsData | null => {
      const { item, render } = goods;
      if (!render || !item) return null;

      const goodsData = convertRenderDataToGoodsData(
        {
          item: { ...item, hasAd: isNotNil(item.ad) },
          render,
        } as RenderableGoodsItem,
        {
          thumbnailSrc: item.image,
          thumbnailOverrides: {
            hideLike: !render.data.actions.includes(
              AblyGoodsCardActionType.Like,
            ),
          },
          nameOverrides: {
            marketName: render.data.store_text ?? item.market_name ?? null,
          },
        },
      );

      return {
        ...goods,
        ...goodsData,
      };
    })
    .filter((v): v is MarketBrandingAdsGoodsData => v !== null);
};
